/*
  b2b.js
  ──────
  Bedienelemente der B2B-Slider: Pfeile und Punkte.

  Der Slider selbst funktioniert OHNE dieses Skript — er ist ein horizontal
  scrollender Flex-Track mit scroll-snap, also per Wischen, Trackpad und
  Tastatur bedienbar. Dieses Skript ergaenzt nur Pfeile und Punkte. Deshalb
  stehen beide im Markup auf `hidden` und werden erst hier eingeblendet:
  Faellt das Skript aus, sieht niemand tote Bedienelemente.

  Kein jQuery. Die drei bisherigen Slider des Shops liefen ueber jQuery-Plugins
  von jsdelivr und waren beim kalten Erstladen unzuverlaessig (siehe CLAUDE.md).
*/
(function () {
  'use strict';

  function initSlider(wurzel) {
    var track = wurzel.querySelector('[data-b2b-slider-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var zurueck = wurzel.querySelector('[data-b2b-slider-zurueck]');
    var vor = wurzel.querySelector('[data-b2b-slider-vor]');
    var punkteBox = wurzel.querySelector('[data-b2b-slider-punkte]');

    // Wie viele Slides passen nebeneinander? Aus den tatsaechlichen Breiten
    // ableiten statt Breakpoints zu doppeln — sonst laufen CSS und JS
    // auseinander, sobald jemand die Spaltenzahl im CSS aendert.
    function proSeite() {
      var breite = slides[0].getBoundingClientRect().width;
      if (!breite) return 1;
      return Math.max(1, Math.round(track.clientWidth / breite));
    }

    function seitenAnzahl() {
      return Math.max(1, Math.ceil(slides.length / proSeite()));
    }

    function aktuelleSeite() {
      var breite = slides[0].getBoundingClientRect().width;
      if (!breite) return 0;
      return Math.round(track.scrollLeft / (breite * proSeite()));
    }

    function geheZu(seite) {
      var breite = slides[0].getBoundingClientRect().width;
      track.scrollTo({ left: seite * breite * proSeite(), behavior: 'smooth' });
    }

    // ── Punkte ──────────────────────────────────────────────────────────
    var punkte = [];

    function punkteAufbauen() {
      if (!punkteBox) return;
      punkteBox.innerHTML = '';
      punkte = [];
      var n = seitenAnzahl();
      if (n < 2) {
        punkteBox.hidden = true;
        return;
      }
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'b2b-slider__punkt';
        b.setAttribute('aria-label', 'Zu Ansicht ' + (i + 1) + ' von ' + n);
        (function (ziel) {
          b.addEventListener('click', function () { geheZu(ziel); });
        })(i);
        punkteBox.appendChild(b);
        punkte.push(b);
      }
      punkteBox.hidden = false;
      standAktualisieren();
    }

    function standAktualisieren() {
      var seite = aktuelleSeite();
      var letzte = seitenAnzahl() - 1;

      punkte.forEach(function (p, i) {
        var aktiv = i === seite;
        p.classList.toggle('is-aktiv', aktiv);
        p.setAttribute('aria-current', aktiv ? 'true' : 'false');
      });

      if (zurueck) zurueck.disabled = seite <= 0;
      if (vor) vor.disabled = seite >= letzte;
    }

    if (zurueck) {
      zurueck.hidden = false;
      zurueck.addEventListener('click', function () { geheZu(aktuelleSeite() - 1); });
    }
    if (vor) {
      vor.hidden = false;
      vor.addEventListener('click', function () { geheZu(aktuelleSeite() + 1); });
    }

    // scroll feuert sehr oft; ueber requestAnimationFrame entprellen.
    var wartet = false;
    track.addEventListener('scroll', function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(function () {
        wartet = false;
        standAktualisieren();
      });
    }, { passive: true });

    var neuAufbauen;
    window.addEventListener('resize', function () {
      clearTimeout(neuAufbauen);
      neuAufbauen = setTimeout(punkteAufbauen, 150);
    });

    punkteAufbauen();
  }

  /*
    Zeitstrahl der Prozess-Schritte. Die Linie steht per CSS bereits voll
    (--b2b-fuellung Standardwert 1); hier wird sie auf 0 gesetzt und beim
    Eintritt in den Viewport auf 1 animiert. Reihenfolge ist wichtig: Erst
    wenn feststeht, dass das Skript laeuft, darf die Linie verkuerzt werden —
    sonst bliebe sie ohne JavaScript unsichtbar.
  */
  /*
    Zeitstrahl der Prozess-Schritte. Die Fuellung folgt dem Scrollstand: Sobald
    der Abschnitt in den Viewport laeuft, waechst die Linie mit — das ist die
    "Fliess-Animation" des Originals. Ein einmaliger Uebergang beim Eintritt
    reicht dafuer nicht, er ist nach einer Sekunde vorbei und reagiert danach
    nicht mehr auf die Bewegung.

    Ohne Skript bleibt die Linie voll (CSS-Standardwert 1), sie ist also in
    jedem Fall sichtbar.
  */
  function initZeitstrahl(wurzel) {
    var raster = wurzel.querySelector('.b2b-icons__raster');
    if (!raster) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function stand() {
      var r = raster.getBoundingClientRect();
      var hoehe = window.innerHeight || document.documentElement.clientHeight;
      // 0 = Oberkante noch unterhalb des Viewports, 1 = Unterkante durchlaufen.
      var start = hoehe * 0.85;
      var ende = hoehe * 0.25;
      var anteil = (start - r.top) / Math.max(1, (start - ende) + r.height);
      if (anteil < 0) anteil = 0;
      if (anteil > 1) anteil = 1;
      raster.style.setProperty('--b2b-fuellung', anteil.toFixed(3));
    }

    var wartet = false;
    function anstossen() {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(function () {
        wartet = false;
        stand();
      });
    }

    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
    stand();
  }

  function start() {
    var slider = document.querySelectorAll('[data-section-type="b2b-slider"]');
    Array.prototype.forEach.call(slider, initSlider);

    var strahl = document.querySelectorAll('.b2b-icons--nummeriert');
    Array.prototype.forEach.call(strahl, initZeitstrahl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Der Theme-Editor baut Sections neu auf, ohne die Seite zu laden.
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-section-type="b2b-slider"]');
    if (s) initSlider(s);
  });
})();
